import { createStyles } from '@material-ui/styles';

export default () =>
  createStyles({
    dynamicField: {
      '& .MuiOutlinedInput-multiline': {
        height: '85%',
        padding: 14,
      },
    },
  });
